import { Paragraph } from "@/components/ui/Typography";
import type { MicroSite } from "@/lib/api";
import { sanitizeHtml } from "@/utils/helpers/html";
const Overview = ({data}:{data: MicroSite}) => {
   

  const PreviewComponent = () => {
    return (
      <div className="flex relative justify-end lg:w-1/3 w-full" >   
          <div className="flex gap-3" style={{color: data?.branding?.textColorCode}}>
          <Paragraph className="text-right " dangerouslySetInnerHTML={{ __html: sanitizeHtml(data?.footerSection?.footerDescription ?? "") }} ></Paragraph>
          </div>
      </div>
    )
  };


  return (
    <>
      <PreviewComponent />
    </>
  )
}

export default Overview